import {forwardRef} from "react";

import {useDialog} from "@datanac/datanac-mui-toolkit";
import {GridActionsCellItem} from "@mui/x-data-grid";
import {DeleteIcon} from "components/Icons/Icons";
import {IconButton} from "@mui/material";

const DeleteConfirmationButton = forwardRef(({
    item,
    onChange,
    mobileDeleteAction = false,
    ...props
}, ref) => {
    const {component: confirmDialogComponent, actions: confirmDialogActions} = useDialog();

    const handleDeleteOnClick = () => {
        confirmDialogActions.confirm({
            title: "Delete this entry?",
            prompt: "Are you sure you want to delete this entry?",
            promptDetail: null,
            callback: () => {
                const _newState = {
                    ...item,
                    is_active: false
                };
                onChange ?. (_newState);
            }
        });
    };

    return (
        <> {
            ! mobileDeleteAction ? <GridActionsCellItem {...props}
                ref={ref}
                key="delete"
                icon={
                    <DeleteIcon
                color="error"/>
                }
                label="Delete"
                onClick={handleDeleteOnClick}/> : <IconButton ref={ref}
                onClick={handleDeleteOnClick}
                aria-label="Delete"
                {...props}>
                <DeleteIcon color="error"/>
            </IconButton>
        }

            {confirmDialogComponent} </>
    );
});

export default DeleteConfirmationButton;
